import React from 'react';
import MainArticleContentItem from './ArticleMainContentItem';
import { HeaderItem } from './utils/helpers';

interface Props {
  articleBody: any[];
  headers: HeaderItem[];
}

export default function MainArticleContent({ articleBody, headers }: Props) {
  if (!articleBody) return null;
  return (
    <div>
      {articleBody.map((item, index) => (
        <MainArticleContentItem articleItem={item} index={index} key={`article-main-content-${index}`} headersList={headers} />
      ))}
    </div>
  );
}
